import { forwardRef, type SVGProps } from 'react';

export const DlnCheckSuccessIcon = forwardRef<
  SVGSVGElement,
  SVGProps<SVGSVGElement>
>(function DlnCheckSuccessIcon(props, ref) {
  return (
    <svg
      ref={ref}
      fill="none"
      viewBox="0 0 48 48"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_1621_10990)">
        <circle cx="24" cy="24" r="22" stroke="currentColor" strokeWidth="4" />
        <path
          clipRule="evenodd"
          d="M16.587 33.412C16.979 33.804 17.45 34 18 34H30C30.5493 34.0007 31.02 33.805 31.412 33.413C31.804 33.021 32 32.55 32 32V20L26 14H18C17.4507 13.9993 16.98 14.195 16.588 14.587C16.196 14.979 16 15.45 16 16V32C15.9993 32.5493 16.195 33.02 16.587 33.412ZM30 21H25V16L30 21ZM22.3221 29.3033C22.3775 29.3233 22.4368 29.3333 22.5002 29.3333C22.5635 29.3333 22.6229 29.3233 22.6783 29.3033C22.7337 29.2835 22.7852 29.2498 22.8327 29.2021L27.2027 24.8113C27.2898 24.7238 27.3333 24.6104 27.3333 24.4711C27.3333 24.332 27.2898 24.2187 27.2027 24.1312C27.1156 24.0437 27.0029 24 26.8645 24C26.7258 24 26.6129 24.0437 26.5258 24.1312L22.5002 28.176L20.802 26.4698C20.715 26.3823 20.6041 26.3386 20.4695 26.3386C20.335 26.3386 20.2241 26.3823 20.137 26.4698C20.05 26.5573 20.0044 26.6706 20.0002 26.8096C19.9964 26.949 20.0381 27.0624 20.1252 27.1499L22.1677 29.2021C22.2152 29.2498 22.2666 29.2835 22.3221 29.3033Z"
          fill="currentColor"
          fillRule="evenodd"
        />
      </g>
      <defs>
        <clipPath id="clip0_1621_10990">
          <rect fill="white" height="48" width="48" />
        </clipPath>
      </defs>
    </svg>
  );
});
